/* eslint-disable @typescript-eslint/restrict-plus-operands */
import {
  type AsyncStateObject, type Action,
  type EngagementUpdateResponse
} from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, ENGAGEMENT_ACTIONS } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<EngagementUpdateResponse> = {
  data: { message: '' },
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined

}

const updateEngagementReducer = (state = INITIAL_STATE, action: Action<EngagementUpdateResponse>) => {
  switch (action.type) {
    case ENGAGEMENT_ACTIONS.UPDATE_ENGAGEMENT + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case ENGAGEMENT_ACTIONS.UPDATE_ENGAGEMENT + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case ENGAGEMENT_ACTIONS.UPDATE_ENGAGEMENT + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case ENGAGEMENT_ACTIONS.UPDATE_ENGAGEMENT + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default updateEngagementReducer
